import React, { useState } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { pushDropdownValue, setLoaders } from '../store/access-graph-slice';
import { useSelector, useDispatch } from 'react-redux';
import { getFilteredData, getgraphData } from '../../services/apiservices';
import { SlectStyle, MenuItemStyle } from './filter-components.styles';
import lowerCase from 'lodash/lowerCase';
import camelCase from 'lodash/camelCase';
export default function SimpleSelect() {
  const [selected, setSelected] = useState('');
  const dispatch = useDispatch();
  const dropdownValue = useSelector(state => state.graph.dropdownValue);
  const filterValue = useSelector(state => state.graph.filterValue);
  const policyData = useSelector(state => state.accordionData.policy);

  const handleChange = event => {
    let selectedValue = event.target.value;
    dispatch(pushDropdownValue(selectedValue));
    dispatch(setLoaders(true));
    let url = `/api/ada/graph/accessmap/ramdetailsbyentitytype?entityType=${camelCase(lowerCase(policyData.objectType))}&key=${policyData.entityUuid}`;

    if (filterValue === 'all') {
      dispatch(getgraphData(url, selectedValue));
    } else {
      dispatch(getFilteredData(url, filterValue, selectedValue));
    }

    setSelected(selectedValue);
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    size: "small"
  }, /*#__PURE__*/React.createElement(SlectStyle, {
    labelId: "demo-simple-select-outlined-label",
    id: "demo-simple-select-outlined",
    value: dropdownValue,
    onChange: handleChange,
    style: {
      fontSize: '12px',
      fontFamily: 'OpenSans-Regular',
      width: '169px',
      height: '29px'
    }
  }, /*#__PURE__*/React.createElement(MenuItemStyle, {
    value: 30,
    selected: selected === '30',
    style: {
      fontSize: '12px',
      fontFamily: 'OpenSans-Regular'
    }
  }, "Last 30 days"), /*#__PURE__*/React.createElement(MenuItem, {
    value: 60,
    selected: selected === '60',
    style: {
      fontSize: '12px',
      fontFamily: 'OpenSans-Regular'
    }
  }, "Last 60 days"), /*#__PURE__*/React.createElement(MenuItem, {
    value: 90,
    selected: selected === '90',
    style: {
      fontSize: '12px',
      fontFamily: 'OpenSans-Regular'
    }
  }, "Last 90 days"))));
}